import { Link } from "react-router-dom";
import type { ReactNode } from "react";
import { SiteFooter } from "../../components/Layout";
import { OPERATOR } from "../../../shared/constants";

export function LegalLayout({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  return (
    <div className="legal-page">
      <header className="landing-header">
        <Link to="/" className="brand">
          {OPERATOR.serviceName}
        </Link>
        <Link to="/" className="btn btn-ghost">
          トップへ
        </Link>
      </header>
      <main className="legal-content card">
        <h1>{title}</h1>
        {children}
      </main>
      <SiteFooter />
    </div>
  );
}
